import { createSvgIcon } from '@mui/material'

export const Multi9PlusIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    height='24px'
    viewBox='0 0 24 24'
    width='24px'
    fill='currentColor'
  >
    <path
      xmlns='http://www.w3.org/2000/svg'
      d='M10 14H12C12.55 14 13.0208 13.8042 13.4125 13.4125C13.8042 13.0208 14 12.55 14 12V8C14 7.45 13.8042 6.97917 13.4125 6.5875C13.0208 6.19583 12.55 6 12 6H11C10.45 6 9.97917 6.19583 9.5875 6.5875C9.19583 6.97917 9 7.45 9 8V9C9 9.55 9.19583 10.0208 9.5875 10.4125C9.97917 10.8042 10.45 11 11 11H12V12H10V14ZM12 9H11V8H12V9ZM8 18C7.45 18 6.97917 17.8042 6.5875 17.4125C6.19583 17.0208 6 16.55 6 16V4C6 3.45 6.19583 2.97917 6.5875 2.5875C6.97917 2.19583 7.45 2 8 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H8ZM8 16H20V4H8V16ZM4 22C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20V6H4V20H18V22H4ZM16.5 13H18.5V11H20V9H18.5V7H16.5V9H14.5V11H16.5V13Z'
      fill='currentColor'
    />
  </svg>,
  'Multi9PlusIcon',
)
